import { useIonAlert } from '@ionic/react';
import { useEffect } from 'react';
import {
  SupportOpenSource,
  useSupportContext,
} from '../../../../components/support/support.context';
import i18n from '../../../../i18n';

export const useToolsNotFoundAlert = ({ show }: { show: boolean }) => {
  const [present, dismiss] = useIonAlert();
  const { open: openSupport } = useSupportContext();

  useEffect(() => {
    if (show) {
      present(i18n.t('common:error_occurred_contact_support'), [
        {
          text: i18n.t('common:support'),
          handler: () => {
            openSupport({
              source: SupportOpenSource.MENU,
              beforeOpen: dismiss,
            });
          },
        },
        {
          text: i18n.t('common:cancel'),
          role: 'cancel',
        },
      ]);
    } else {
      dismiss();
    }

    return () => {
      dismiss();
    };
  }, [dismiss, openSupport, present, show]);
};
